export default __webpack_public_path__ + "static/media/arrow.16866fe9.svg";